var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.19922H4.88672V6.75C4.88672 5.53125 5.53125 4.91016 6.70312 4.91016H9.12891V3.02344H6.67969C4.23047 3.02344 3 4.23047 3 6.65625V9.19922ZM10.7344 4.91016H16.8398V3.02344H10.7344V4.91016ZM22.6875 9.19922H24.5742V6.65625C24.5742 4.24219 23.3438 3.02344 20.8945 3.02344H18.4453V4.91016H20.8711C22.0312 4.91016 22.6875 5.53125 22.6875 6.75V9.19922ZM22.6875 16.8164H24.5742V10.8047H22.6875V16.8164ZM18.4453 24.5977H20.8945C23.3438 24.5977 24.5742 23.3789 24.5742 20.9648V18.4219H22.6875V20.8711C22.6875 22.0898 22.0312 22.7109 20.8711 22.7109H18.4453V24.5977ZM10.7344 24.5977H16.8398V22.7109H10.7344V24.5977ZM6.67969 24.5977H9.12891V22.7109H6.70312C5.53125 22.7109 4.88672 22.0898 4.88672 20.8711V18.4219H3V20.9648C3 23.3906 4.23047 24.5977 6.67969 24.5977ZM3 16.8164H4.88672V10.8047H3V16.8164Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareSelect);
export default __webpack_public_path__ + "static/media/square_select.b5c1c9159a9a8c356e087c71f9bcad46.svg";
export { ForwardRef as ReactComponent };